import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EscolhaModalidadeService } from 'src/app/shared/services/escolha-modalidade.service';
import { ModalidadeGarantia } from '../../model/modalidade_garantia.model';
import { ModalidadeService } from '../../shared/services/modalidade.service';

@Component({
    selector: 'app-escolha-modalidade',
    templateUrl: './escolha-modalidade.component.html',
    styleUrls: ['./escolha-modalidade.component.css'],
    standalone: false
})
export class EscolhaModalidadeComponent implements OnInit {

  public modalidades: ModalidadeGarantia[];

  constructor(private router: Router, private route: ActivatedRoute,
    private escolhaModalidadeService: EscolhaModalidadeService,
    private modalidadeService: ModalidadeService) { }

    escolhaModalidade(modalidade) {
        this.escolhaModalidadeService.associarModalidade(modalidade);

        const returnUrl = this.route.snapshot.queryParams['returnUrl']

        if (returnUrl && returnUrl.startsWith('http')) {
            window.location.href = returnUrl;
        } else if (returnUrl) {
            this.router.navigateByUrl(returnUrl);
        } else {
            this.router.navigate(['/home']);
        }
    }

    ngOnInit(): void {
        this.modalidades = this.modalidadeService.getModalidades();
        if (this.modalidades.length == 0) {
            this.modalidadeService.getModalidadesAssincrono().subscribe(modalidades => this.modalidades = modalidades);
        }
    }
}
